<template>
  <div>
    <BaseBrIndex type="all" :br-type="21" />
  </div>
</template>

<script>
import BaseBrIndex from './index.vue';

export default {
  components: { BaseBrIndex }
};
</script>

<style lang="less" scoped></style>
